module.exports = __webpack_public_path__ + "sy.fc44370ffd2df5df38bb.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sy.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sy.svg
// module chunks = styles